import { ConfigProps } from './Props';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { useNavigate, createSearchParams } from 'react-router';

interface Props {
  configs: ConfigProps[];
}

const Config: React.FC<Props> = ({ configs }) => {
  const navigate = useNavigate();

  const onClick = (cid: number) => {
    navigate({
      pathname: '/configinfo',
      search: `?${createSearchParams({ id: cid.toString() })}`,
    });
  };

  return (
    <div className="configs">
      {configs.map((c, i) => (
        <div className="config" onClick={() => onClick(c.id)}>
          <Card sx={{ minWidth: 300, minHeight: 150 }}>
            <CardContent>
              <Typography variant="h5">{c.configName}</Typography>
              <Divider />
              <Typography variant="body1">{c.channel}</Typography>
              <Typography variant="body1">{c.subChannel}</Typography>
            </CardContent>
          </Card>
        </div>
      ))}
    </div>
  );
};

export default Config;
